import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import Cookies from 'js-cookie';

import { ContentTypeValue, HttpHeaders } from './types/headers.types';
import { CookieKey } from './types/cookies.types';

export type HTTPHeaderList = { key: string; value: string }[];

// Global singleton
export class Request {
    private static readonly TIMEOUT = 15000;

    private static instance: AxiosInstance = axios;

    protected static addHeader(httpHeaders: HTTPHeaderList, config?: AxiosRequestConfig) {
        const initialHeaders = httpHeaders.reduce((res, { key, value }) => {
            if (value === null || value === undefined) {
                return res;
            }
            return { ...res, [key]: value };
        }, {});

        if (!config) {
            return {
                headers: initialHeaders,
            };
        }
        return {
            ...config,
            headers: {
                ...initialHeaders,
                ...config.headers,
            },
        };
    }

    public static init() {
        Request.instance = axios.create({
            // baseURL: process.env.API_DOMAIN,
            baseURL: process.env.SEEL_API_DOMAIN,
            timeout: Request.TIMEOUT,
        });
    }

    public static async get<T = any>(
        url: string,
        config?: AxiosRequestConfig
    ): Promise<AxiosResponse<T>> {
        // Merge headers into the config
        const withDefaultHeaderConfigs = Request.addHeader(
            [{ key: HttpHeaders.XAccessToken, value: Cookies.get(CookieKey.XAccessToken) }],
            config
        );

        try {
            const response = await Request.instance.get<T>(url, withDefaultHeaderConfigs);
            return response;
        } catch (err) {
            console.error(err);
            throw err.response;
        }
    }

    public static async post<T = any, R = unknown>(
        url: string,
        data?: R,
        config?: AxiosRequestConfig
    ): Promise<AxiosResponse<T>> {
        // Merge default headers
        const withDefaultHeaderConfigs = Request.addHeader(
            [
                { key: HttpHeaders.XAccessToken, value: Cookies.get(CookieKey.XAccessToken) },
                { key: HttpHeaders.ContentType, value: ContentTypeValue.Json },
            ],
            config
        );

        try {
            const response = await Request.instance.post<T>(
                url,
                JSON.stringify(data),
                withDefaultHeaderConfigs
            );
            return response;
        } catch (err) {
            console.error(err);
            throw err.response;
        }
    }
}
